/* eslint-disable */
import Highcharts from "highcharts";

export const lineChartOptionsPrd: Highcharts.Options = {
  title: {
    text: "Chart Production",
  },
  credits: {
      enabled: false
  },
  series: [
    {
      type: "line",
      data: [1, 2, 3, 8, 4, 7],
    },
    {
      type: "line",
      data: [5, 7, 6, 9, 5, 4],
    },
  ],
};